module.exports = "/_next/static/images/45676c73cf00fadfd30f09bab839913b-security-mobile.jpg.webp";